import styled from "styled-components";
import BaseInputLike from "../InputLike";

export const TextAreaWrapper = styled(BaseInputLike)`
    cursor: text;
`;

export const TextArea = styled.textarea``;
